export const preferredCountriesList = [
  "SA",
  "AE",
  "OM",
  "BH",
  "KW",
  "QA"
]

export const defaultCountry = "SA";